import { connect } from 'react-redux';
import PurchaseOrderLineDetails from './PurchaseOrderLineDetails';
import { getFormValues, change } from 'redux-form';
import { IApplicationState } from 'ducks/reducers';
import { bindActionCreators, Dispatch } from 'redux';

const FORM_NAME = 'PurchaseOrderLineDetailsForm';
const mapStateToProps = (state: IApplicationState) => ({
    formValues: getFormValues(FORM_NAME)(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeFieldValue: (field, value) => change(FORM_NAME, field, value),
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderLineDetails);
